import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { SectionCollapse } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useChatbotContext } from 'pages/chatbot/context'
import { StepQualifyContent } from 'pages/chatbot/ui/ChatbotEdit/StepQualify/ui/StepQualifyContent/StepQualifyContent'

export const StepQualify = observer(() => {
  const { fieldsControl, stepQualifyStore, errorObjectiveQualifyInstruction } = useChatbotContext()
  const { featureFlagsStore } = useEntitiesContext()

  useEffect(() => {
    fieldsControl.init()
    stepQualifyStore.initDefault()

    return () => {
      stepQualifyStore.dispose()
    }
  }, [])

  if (!featureFlagsStore.qualify) return null

  return (
    <SectionCollapse
      icon='usersCheck'
      title='Qualify'
      tooltipProps={{
        label: 'Agent will qualify contacts before continuing the conversation',
        placement: 'top',
        sx: { whiteSpace: 'nowrap' },
        maxWidth: 'none',
      }}
      error={errorObjectiveQualifyInstruction}
      dataError={!!errorObjectiveQualifyInstruction}
    >
      <StepQualifyContent type={'default'} />
    </SectionCollapse>
  )
})
